import { render, staticRenderFns } from "./CmgRewardsAchievementsHeader.vue?vue&type=template&id=7844741b&scoped=true&lang=pug"
import script from "./cmg-rewards-achievements-header.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-achievements-header.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsAchievementsHeader.vue?vue&type=style&index=0&id=7844741b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844741b",
  null
  
)

export default component.exports